import { useContext } from "react";
import { PackageContext } from "./PackageContext";

export const usePackage = () => {
  const context = useContext(PackageContext);

  if (!context) {
    throw new Error("usePackage must be used inside PackageProvider");
  }

  return context;
};
